module.exports = __webpack_public_path__ + "img/order.445e8ef9.svg";